import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux';

import SignatureIframe from './components/SignatureIframe';

import { InfoBox } from 'hosman-material';

import { genereteMandate } from '../../../../../../../reducers/SellerApp/mandatesSlice';
import SuccessAnimation from './components/SuccessAnimation';

const Signature = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { mandate, yousignStatus } = useSelector((state) => state.sellerMandates);
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      dispatch(genereteMandate(mandate.id));
    }
  }, []);

  return (
    <div className='flex flex-col gap-8 text-ih-indigo w-full' data-testid='Signature'>
      <p className='h2 text-center'>Veuillez lire et signer votre mandat</p>

      <InfoBox avatarSrc={sale.expert?.user?.profile_pic_url}>
        Veuillez prendre connaissance du mandat dans son intégralité. Une fois arrivé en bas, cliquez sur "Signer". 
        Vous pourrez alors signer électroniquement, par le biais d'un SMS de vérification envoyé à votre numéro.
      </InfoBox>

      <SignatureIframe />

      {(yousignStatus === 'success') &&
        <SuccessAnimation />
      }
      
    </div>
  );
}

export default Signature;
